import styled from 'styled-components'

import FormFieldInput from '../FormFieldInput'
import Icon from '../../../components/Icon'

export const Input = styled(FormFieldInput)``
export const Email = styled(Icon)``
